import PropTypes from "prop-types";
import classNames from "classnames";

const prefix = "t-base";

const Base = ({
  align = "center",
  children,
  className,
  footer,
  header,
  headerClass,
  ...props
}) => {
  const componentClass = classNames(prefix, "w-full h-full flex flex-wrap flex-col", {
    [className]: className
  });

  const classForHeader = classNames({
    [`${prefix}__header flex-none px-3 py-5 flex flex-wrap justify-center gap-10`]: header,
    [headerClass]: header && headerClass
  });

  return (
    <div className={componentClass} {...props}>
      {header && <div className={classForHeader}>
        {header}
      </div>}

      <div className={`${prefix}__content flex-auto content-${align} flex flex-wrap px-3 py-5`}>
        {children}
      </div>

      
      {footer && <div className={`${prefix}__footer flex-none p-3 flex flex-wrap justify-center gap-10`}>
        {footer}
      </div>}
    </div>
  );
};

Base.propTypes = {
  headerClass: PropTypes.string,
  align: PropTypes.oneOf(["normal", "center", "start", "end", "between", "around", "evenly", "baseline", "stretch"])
};

export default Base;
